import { createSelector } from 'reselect';

const selectGlobals = (state: any) => state.globals;


export const selectGlobalsCurrentItem = createSelector([selectGlobals], (globals) => globals.current);

export const selectGlobalsListItems = createSelector([selectGlobals], (globals) => globals.list);

export const selectGlobalsItemById = (itemId: any) =>
    createSelector(selectGlobalsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalsQueryItems = createSelector([selectGlobals], (globals) => globals.query);

export const selectGlobalsCreatedItem = createSelector([selectGlobals], (globals) => globals.create);

export const selectGlobalsUpdatedItem = createSelector([selectGlobals], (globals) => globals.update);

export const selectGlobalsReadItem = createSelector([selectGlobals], (globals) => globals.read);

export const selectGlobalsDeletedItem = createSelector([selectGlobals], (globals) => globals.delete);

export const selectGlobalsSearchedItems = createSelector([selectGlobals], (globals) => globals.search);

export const selectGlobalsItemsCount = createSelector([selectGlobals], (globals) => globals.count);

export const selectGlobalsItemsFilter = createSelector([selectGlobals], (globals) => globals.filter);